(function (ws) {
    'use strict';

    ws.views.resetQuotePricing = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-rest-price-continue': 'resetQuotePriceContinue',
            'click .qut-rest-price-no-change-continue': 'resetQuotePriceNoChangeContinue',
            'change [name="selectedOption"]': 'selectedOptionChanged',
            'click .qut-rest-price-no-change-cancel': 'showButtonsHideSection'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
            this.$button = this.$('.qut-rest-price-continue');
            this.$noChangeContinueButton = this.$('.qut-rest-price-no-change-continue');
            this.eventAgg.on('resetQuotePricingEndUser', this.resetQuotePricingEndUser, this);
        },

        resetQuotePricingEndUser: function (endUserSapId, trilliumResponse) {
            this.eventAgg.trigger(this.$el.attr('id'));
            if ($('#hasConfigureskusIdQuote').val() === 'true') {
                this.eventAgg.trigger('getConfiguratorChildInfo');
                var strToArr = $('#isConfiguredChildChecked').val().split(',');
                if (strToArr && strToArr.includes('CONFIGURED_CHILD')) {
                    $('.pricingResetwarning').removeClass('hide');
                } else {
                    $('.pricingResetwarning').addClass('hide');
                }
            }

            if (this.$('.mergeQuoteResetQuotePricing').length) {
                this.$('.mergeQuoteResetQuotePricing').show();
                this.$('.sbaQuoteResetQuotePricing').hide();
                setTimeout(() => {
                    this.$('.mergeQuoteOption').prop('checked', true);
                }, 500);
            } else {
                this.$('.sbaQuoteResetQuotePricing').show();
            }

            this.$('.invalid-combination-section').hide();
            this.$('.modalBtn').show();
            this.$('.qut-rest-price-continue').removeClass('spinner-after');
            this.$('input:radio[name=selectedOption]').filter('[checked=checked]').prop('checked', true);
            this.$button.attr('data-enduser', endUserSapId);
            this.$button.attr('data-trilliumres', trilliumResponse);
            this.$noChangeContinueButton.attr('data-enduser', endUserSapId);
            this.$noChangeContinueButton.attr('data-trilliumres', trilliumResponse);

        },

        /**
         * tigger the resetQuotePrices
         */
        resetQuotePriceContinue: function (e) {

            let selectedOption = this.$('input[name=selectedOption]:checked').val();
            let _this = this;
            let url = '/quote/getInvalidSBA/' + e.target.dataset.enduser + '/' + $('[name="quoteCode"]').val();

            if (selectedOption == 'NO_CHANGE') {
                this.$('.qut-rest-price-continue').addClass('spinner-after');
                globals.disableApp();
                $.get(url, function (res) {
                    globals.enableApp();
                    if (res.invalidSba === true) {
                        _this.$('.qut-rest-price-continue').removeClass('spinner-after');
                        _this.$('.modalBtn').slideUp();
                        _this.$('.invalid-combination-section').slideDown();
                    } else if (res.invalidSba === false) {
                        _this.resetQuotePriceNoChangeContinue(e);
                    }
                });
            } else {
                this.resetQuotePriceNoChangeContinue(e);
            }
        },

        resetQuotePriceNoChangeContinue: function (e) {
            this.eventAgg.trigger('callingSearchEndUserAPI', e.target.dataset.enduser, this.$('input[name=selectedOption]:checked').val(), e.target.dataset.trilliumres);
            this.closeModal();
        },

        selectedOptionChanged: function() {
            if (this.$('.invalid-combination-section').is(':visible')) {
                if (['EXCEPT_RESELLER_EXTENDED_PRICE', 'ALL'].indexOf(this.$('input[name=selectedOption]:checked').val()) !== -1) {
                    this.showButtonsHideSection();
                }
            }
        },

        showButtonsHideSection: function () {
            this.$('.invalid-combination-section').slideUp();
            this.$('.modalBtn').slideDown();
        }
    });
}(westcon));
